import { useNavigate } from 'react-router-dom'

import type { ReactElement } from 'react'

import AppLogo from '~/components/AppLogo'
import MwMLoader from '~/components/MwMLoader'
import Tooltip from '~/components/Tooltip'
import { dataNotAvailableText } from '~/const'
import { useAppSummary } from '~/providers/AppSummary'
import { useSearchParamsContext } from '~/providers/SearchParams'
import { useGetAppCompetitorsQuery } from '~/queries/clusters'
import { getExternalStoreId } from '~/utils/application'

import './styles.scss'

const CompetitorsBlock = (): ReactElement => {
  /** Local state */

  const { appDetails, deviceType } = useAppSummary()

  const navigate = useNavigate()

  const { dispatchToSearchParams } = useSearchParamsContext()

  /** Queries & Mutations */

  const { data: competitorsData = [], isLoading: isCompetitorsLoading } = useGetAppCompetitorsQuery({
    deviceType,
    storeId: appDetails ? getExternalStoreId(appDetails, deviceType) : undefined,
  })

  /** Handlers */

  const handleRedirectToVersion = (externalId: string) => () => {
    dispatchToSearchParams({ type: 'update', value: { externalId } })
    navigate('/versions')
  }

  /** Render */

  if (isCompetitorsLoading) return <MwMLoader category="item" />

  if (!competitorsData.length) return <span>{dataNotAvailableText}</span>

  return (
    <div className="competitors-container">
      {competitorsData?.slice(0, 4).map(({ device_type, icon_url, name, store_id }) => (
        <Tooltip
          className="competitor-preview__tooltip"
          key={store_id}
          mouseEnterDelay={0.2}
          overlay={
            <>
              <span className="competitor-name">{name}</span>
              <span className="competitor-store-id">Store ID: {store_id}</span>
            </>
          }
          placement="top"
          trigger="hover"
        >
          <div className="competitor-preview__logo-wrapper" onClick={handleRedirectToVersion(store_id)}>
            <AppLogo
              appLogoUrl={icon_url}
              appPlatform={device_type}
              className="competitor-preview__logo-wrapper__logo"
              size="medium"
            />
          </div>
        </Tooltip>
      ))}
    </div>
  )
}

export default CompetitorsBlock
